var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('radio-group',{staticClass:"grid-radio-group",attrs:{"options":_vm.options,"rowIndex":_vm.rowIndex,"cellIndex":_vm.cellIndex,"propValue":_vm.propValue},on:{"change":_vm.changeHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }